import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

export interface ICellRendererParamsForExpandCellHeaderParams extends IHeaderParams {
    expandAll: (params: ICellRendererParamsForExpandCellHeaderParams) => void;
    collapseAll: (params: ICellRendererParamsForExpandCellHeaderParams) => void;
    canExpandAll: (params: ICellRendererParamsForExpandCellHeaderParams) => boolean;
    canCollapseAll: (params: ICellRendererParamsForExpandCellHeaderParams) => boolean;
    headerText: string;
}

@Component({
    selector: 'expand-cell-header',
    template: `
<span class="expand-controls">
  @if (params.canCollapseAll(params)) {
    <span class="fa node-expanded" (click)="params.collapseAll(params)" title="Collapse all"></span>
  }
  @if (params.canExpandAll(params)) {
    <span class="fa node-collapsed" (click)="params.expandAll(params)" title="Expand all"></span>
  }
</span> {{params.headerText}}`,
    standalone: false
})
export class ExpandCellHeaderRendererComponent implements IHeaderAngularComp {
    params: ICellRendererParamsForExpandCellHeaderParams;

    agInit(params: ICellRendererParamsForExpandCellHeaderParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
